import { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import FireStoreParser from 'firestore-parser';
import { DataContext } from '../context/data-context';

export const usePlayer = (fogisId) => {
  const { endpointUrl } = useContext(DataContext);
  const [data, setData] = useState(null);
  const [loading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios
      .get(`${endpointUrl}data-endpoint/player?id=${fogisId}`)
      .then((response) => {
        setData(FireStoreParser(response.data)?.fields);
        setIsLoading(false);
      })
      .catch((err) => {
        setError(err);
        setIsLoading(false);
        setData(null);
      });
  }, [endpointUrl, fogisId, setData]);

  return [data, loading, error];
};
